<script setup lang="ts">
import ProviderCard from '~/components/category/provider-card.vue';
import { providerWeightings } from 'assets/data/providerWeightings';
import ExternalIcon from '../design-system/icons/ExternalIcon.vue';
interface IProviderProps {
  providers: string[] | undefined[];
}

const gameStore = useGameStore();
const page = useGetPage({ setSeoMeta: false });

const props = withDefaults(defineProps<IProviderProps>(), {
  providers: [],
});

const route = useRoute();

const sortedProviders = computed(() => {
  const weightings =
    providerWeightings?.[page.value?.Mapping] || providerWeightings['Home'];
  const mappedProviders = props.providers.map((provider) => {
    return {
      provider,
      weight: weightings[provider],
    };
  });
  return mappedProviders
    .sort((a, b) => a.weight - b.weight)
    .map(({ provider }) => provider)
    .filter((p) => !gameStore.returnHiddenProviders.includes(p));
});
</script>

<template>
  <UserInterfaceGenericCarousel
    :id="`${route.params.contentType || 'home'}-providers`"
    :title="$t('providers')"
    display-show-all
    :route="`/${route.params.contentType || 'home'}/providers`"
  >
    <template #icon>
      <slot name="icon" />
      <ExternalIcon v-if="!$slots.icon" icon-name="providers" class="mr-2" />
    </template>
    <ProviderCard
      v-for="(provider, index) in sortedProviders"
      :key="index"
      :provider="provider"
      is-carousel
    />
  </UserInterfaceGenericCarousel>
</template>
